import Inputmask from "inputmask";

export const initPremiumUpgrade = () => {
  const upgradePage = document.getElementById("upgrade-page") as HTMLDivElement;

  if (!upgradePage) {
    return;
  }

  const prepaidInput = upgradePage.querySelector(".prepaid-input") as HTMLInputElement;

  const im = new Inputmask("*{4,5}-*{4}-*{4}", { casing: "upper" });
  im.mask(prepaidInput);

  const prepaidToggle = upgradePage.querySelector(".prepaid-toggle") as HTMLButtonElement | null;
  const prepaidFormWrapper = upgradePage.querySelector(
    ".prepaid-form-wrapper",
  ) as HTMLDivElement | null;

  const prepaidToggleIconClosed = prepaidToggle?.querySelector(".prepaid-toggle-icon-closed");
  const prepaidToggleIconOpen = prepaidToggle?.querySelector(".prepaid-toggle-icon-open");

  prepaidToggle?.addEventListener("click", () => {
    const isHidden = prepaidFormWrapper?.hasAttribute("hidden");
    prepaidFormWrapper?.toggleAttribute("hidden", !isHidden);
    prepaidToggle.setAttribute("aria-expanded", String(isHidden));
    prepaidToggleIconClosed?.classList.toggle("d-none", isHidden);
    prepaidToggleIconOpen?.classList.toggle("d-none", !isHidden);

    if (isHidden) {
      prepaidInput.focus();
    }
  });
};
